(() => {
  if (window.coffeeThirdPartyInitialized) return;
  window.coffeeThirdPartyInitialized = true;
  const config = document.currentScript.dataset;
  const requireConsent = config.requireConsent === 'true';
  const requests = new Map();
  window.dataLayer = window.dataLayer || [];
  window.klaviyo = window.klaviyo || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  function load(src, id) {
    if (requests.has(src)) return requests.get(src);
    const existing = Array.from(document.scripts).find((script) => script.src === src);
    if (existing) {
      const promise = Promise.resolve(existing);
      requests.set(src, promise);
      return promise;
    }
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      if (id) script.id = id;
      script.onload = () => resolve(script);
      script.onerror = () => {
        requests.delete(src);
        script.remove();
        reject(new Error(`Could not load ${new URL(src).hostname}`));
      };
      document.head.appendChild(script);
    });
    requests.set(src, promise);
    return promise;
  }

  function update() {
    const privacy = window.Shopify?.customerPrivacy;
    if (requireConsent && !privacy) return;
    const analytics = requireConsent ? privacy.analyticsProcessingAllowed() : true;
    const marketing = requireConsent ? privacy.marketingAllowed() : true;
    window.gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
    });
    if ((analytics || marketing) && config.gtm) {
      if (!requests.has(config.gtm)) window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      load(config.gtm).catch(console.error);
    }
    if (analytics) {
      if (config.hubspot) load(config.hubspot, 'hs-script-loader').catch(console.error);
      if (config.metricool && !requests.has(config.metricool)) {
        load(config.metricool).then(() => {
          if (!requireConsent || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) {
            window.beTracker?.t({ hash: config.metricoolHash });
          }
        }).catch(console.error);
      }
    }
    if (marketing && config.klaviyo) load(config.klaviyo).catch(console.error);
  }

  if (!requireConsent) {
    update();
    return;
  }

  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('customerPrivacyApiLoaded', update);
  if (window.Shopify?.customerPrivacy) update();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) update();
  });
})();
